"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPrintSizeModeId = exports.setPackingMode = void 0;
const immer_1 = require("immer");
const openingPacker_1 = require("../../../lib/prints/openingPacker");
const printSizes_1 = require("../../../lib/prints/printSizes");
const typedLocalStorage_1 = require("../../../lib/browser/typedLocalStorage");
const MapmakerApi_1 = require("../../../client/MapmakerApi");
const SET_PACKING_MODE = "print_size_settings.set_packing_mode";
const SET_PRINT_SIZE_MODE_ID = "print_size_settings.set_print_size_mode_id";
const localItem = (0, typedLocalStorage_1.LocalItem)("mapmaker.printSizeSettings", 1);
function setPackingMode(packingMode) {
    return {
        type: SET_PACKING_MODE,
        packingMode,
    };
}
exports.setPackingMode = setPackingMode;
function setPrintSizeModeId(printSizeModeId) {
    return {
        type: SET_PRINT_SIZE_MODE_ID,
        printSizeModeId,
    };
}
exports.setPrintSizeModeId = setPrintSizeModeId;
// Makes sure the settings are valid for the given print service.  gets defaults if not.
function getSafeSettings(settings, service) {
    if (service.printSizeModes.find(printSizeMode => printSizeMode.id === settings.printSizeModeId)) {
        return settings;
    }
    else {
        return Object.assign(Object.assign({}, settings), { printSizeModeId: service.printSizeModes[0].id });
    }
}
function createPrintSizeSettingsReducer(file, printService) {
    const { design } = file;
    return (0, immer_1.produce)((draft, action) => {
        if (draft === undefined) {
            const localSettings = localItem.get();
            if (localSettings !== null) {
                return getSafeSettings(localSettings, printService);
            }
            else {
                const singlePrintMode = file.outputType === MapmakerApi_1.ProjectOutputType.MatboardWallMapSingle;
                const printSizeModeId = singlePrintMode
                    ? printSizes_1.PrintSizeModeId.FULL_SIZE
                    : printService.printSizeModes[0].id;
                return {
                    packingMode: openingPacker_1.PackingMode.MULTI,
                    printSizeModeId,
                };
            }
        }
        switch (action.type) {
            case SET_PACKING_MODE:
                draft.packingMode = action.packingMode;
                localItem.put(draft);
                break;
            case SET_PRINT_SIZE_MODE_ID:
                draft.printSizeModeId = action.printSizeModeId;
                localItem.put(draft);
                break;
            default:
                break;
        }
    });
}
exports.default = createPrintSizeSettingsReducer;
//# sourceMappingURL=data:application/json;base64,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